export const EntryLineStatus = {
  cancellationByClient: 0,
  cancellationByYou: 1,
  noAllotment: 2,
  offer: 3,
  ok: 4,
  option: 5,
  onRequest: 6,
  requestConfirmed: 7,
  requestDenied: 8,
  requestSent: 9,
  pending: 10,
  notBookable: 11,
  noAllotmentFallbackToRealtimeFlight: 12,
  notBookableFallbackToRealtimeFlight: 13,
  error: 14,
  bookingConfirmed: 15,
  cancellationConfirmed: 16,
};
